export enum ProductionProcesses {
  Dyeing = 'DYEING',
  Blending = 'BLENDING',
  Carding = 'CARDING',
  Spinning = 'SPINNING',
  Warping = 'WARPING',
  Weaving = 'WEAVING',
  Mending = 'MENDING',
  Inspection = 'INSPECTION',
  Finishing = 'FINISHING',
  Picking = 'PICKING',
}
